@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.info-message {
  padding-bottom: 10px;
  line-height: 22px;
}

.overwrite-message {
  font-size: 12px;
  margin-top: 10px;
  line-height: 16px;
}

.no-ids-container {
  width: 75%;
  margin: auto;
  text-align: center;
  line-height: 22px;
}

.no-ids-message {
  margin-bottom: 10px;
}

.no-ids-instructions {
  color: @bulk-actions--add-tax-ids-no-ids--text-color;
}
